<panel width="600">
	<h1>{{ title }}</h1>
	<section>
		<p>{{ text }}</p>
		@if (details) {
			<p>{{ details }}</p>
		}
	</section>
	<section>
		@for (button of buttons; track button) {
			<button [attr.confirm]="button.type == 'confirm' ? '' : null" [attr.reject]="button.type == 'reject' ? '' : null" [attr.ghost]="button.type == 'ghost' ? '' : null" [ignoreValidation]="true" [label]="button.text | translate" (click)="closeView(button.value)"></button>
		}
	</section>
</panel>
